import { dateStringToDate } from "../../../helpers/time";

class dsStudentInfoOverviewController {
  constructor($state, UserService) {
    this.$state = $state;
    this.currentUser = UserService.getCurrentUser();
  }

  toggleNotebook() {
    if (this.currentUser.usertype_id === 3) {
      this.$state.go();
    } else {
      this.$state.go("drivecoach.admin.students.view.notes", {
        userId: this.student.id,
      });
    }
  }

  getStudentAge() {
    if (this.student === null) {
      return 100;
    }
    if (typeof this.student.usermeta === "undefined") {
      return 100;
    }
    if (typeof this.student.usermeta.dob === "undefined") {
      return 100;
    }
    const dob = dateStringToDate(this.student.usermeta.dob);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  }
}
dsStudentInfoOverviewController.$inject = ["$state", "UserService"];
export default dsStudentInfoOverviewController;
